// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".shop .shop-list .shop-list-inner-wrapper .shop-list-box-text-block .shop-desc[data-v-14deae3d],.shop .shop-list .shop-list-inner-wrapper .shop-list-box-text-block .shop-price[data-v-14deae3d]{will-change:transform}.old-price[data-v-14deae3d]{font-size:15px;text-decoration:line-through}", ""]);
// Exports
module.exports = exports;
